export default function () {
  /* 表格列头 */
  return [
    { label: "序号", type: "index", width: 80 },
    { label: "视频ID", prop: "video_id", width: 100, },
    { label: "点赞小程序openid", prop: "openid", },
    { label: "点赞手机号", prop: "phone", slots: "phone"},
    {
      label: "点赞时间",
      prop: "createTime",
      width: 180,
    },
    {
      label: "操作",
      prop: "operation",
      width: 80,
      slots: "operation",
      fixed: "right",
    },
  ];
}
